import { render, staticRenderFns } from "./UpgradeBasicToMulti.vue?vue&type=template&id=1f7b5075"
import script from "./UpgradeBasicToMulti.vue?vue&type=script&lang=js"
export * from "./UpgradeBasicToMulti.vue?vue&type=script&lang=js"
import style0 from "./UpgradeBasicToMulti.vue?vue&type=style&index=0&id=1f7b5075&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports